import { addPageToViewed } from '../../redux/actions/ui/addPageToViewed';
import defaultLayout from '../../config/templates/layouts/default.json';
import { setFetchDefaults } from '../actions/entities/io';
import { loadBook } from './../../redux/helpers/loadBook';
import { loadSpineDefaults } from '../actions/entities/cover';
import { imageChange } from '../actions/ui/imageChange';
// Pro  beliv
import loadProBelivTemplates from '../../config/templates/layouts/pro';

// Pro / consumer cover
import loadProCoverTemplates from '../../config/templates/covers/pro';
import loadConsumerCoverTemplates from '../../config/templates/covers/consumer';

import {
  loadLayouts,
  setIsActiveLayout,
  removeDefaultLayout,
} from '../actions/entities/layouts';

import {
  setLayoutToActivePage,
  setIsActive,
  createPage,
  addCoverToPage,
} from '../actions/entities/pages';

import {
  getAutoFill,
  getBookId,
  getDomain,
  getContext,
} from './getParams';

import {
  addBookId,
  addContext,
  addFolderId,
  saveBookSizes,
  getBookCover,
  getBookDimensions,
  getCoverMargins,
  getCoverSizes,
  addAutoFill,
  maxSheets,
  addPlaceholderBorderSize,
  setIsBabyBook,
  isLoadadble,
} from '../actions/bookproperties';

import {
  configExist,
  MmToPx,
  getRatio,
  getCoverOrientation,
  getFlyleafFront,
  getFlyleafBack,
  loadDefaultImages,
  startAutofill,
  showAlertModal,
} from './';

import {
  skipImageDropToCover,
  insertTextHelpCover,
  coverWithOnlyAutofillLayout } from './../../helpers/coverHelper';
import { createStore } from 'redux';
import { changeBookBackgroundType } from '../actions/ui/bookProperties';

export function setFirstLayout(store, layoutId, pageId) {
  store.dispatch(addCoverToPage(pageId));
  store.dispatch(setLayoutToActivePage(layoutId, pageId));
  store.dispatch(setIsActiveLayout(layoutId));
  store.dispatch(loadSpineDefaults());
  store.dispatch(setFetchDefaults());
  store.dispatch(setIsActive(pageId));
}

// Set default margin
function defaultMargin() {
  return {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  };
}

function coverOrientation(pageWidth, pageHeight) {
  return getCoverOrientation(pageWidth, pageHeight);
}

// Set cover and margin size to book
function setNewCoverAndMargin(store, cover) {
  store.dispatch(loadLayouts(cover));
  store.dispatch(getCoverMargins(cover[0].margin));
  const coverWidth = cover[0].width;
  const coverHeight = cover[0].height;

  store.dispatch(getCoverSizes(
    coverWidth,
    coverHeight,
    MmToPx(coverWidth),
    MmToPx(coverHeight),
  ));
}

// Set flyleaf to book
function setFlyLeafs(store, format) {
  const frontFlyleafLayouts = getFlyleafFront(format);
  store.dispatch(loadLayouts(frontFlyleafLayouts));

  const backFlyleafLayouts = getFlyleafBack(format);
  store.dispatch(loadLayouts(backFlyleafLayouts));
}

// Set autofill
function ifHaveAutofill(store, lang, maxSheets, autoFill) {
  if (autoFill) {
    startAutofill(store, lang, maxSheets);
  }
}

// Load Gallery
function loadGalleryImages(store, referer, bookId, lang, maxSheets, autoFill, context = 'pro', format) {
  const url = configExist('legacyContent', referer);

  const parameters = 'api/book/';
  const filterType = getAutoFill() !== null ? '?filter=selected' : '';
  const galleryURI = `${url}/${parameters}${bookId}/galleries${filterType}`;
  fetch(galleryURI, {
    cors: 'no-cors',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    credentials: 'include',
  })
    .then(response => response.json())
    .then((galleryData) => {
      if ('error' in galleryData) {
        throw galleryData.error;
      }
      loadDefaultImages(galleryData, store);
    })
    .then(() => {
      // if (context === 'consumer') {
      const { isBabyBook, cover } = store.getState().bookProperties;
      if (!isBabyBook || isBabyBook === undefined) {
        if (insertTextHelpCover().includes(cover.type)) {
          showAlertModal(lang.select_background_on_start, lang.background_types, '').then(() => {
            showAlertModal(lang.title_notice, lang.calligrafia_help, '');
          });
        } else {
          showAlertModal(lang.select_background_on_start, lang.background_types, '');
        }
      } else {
        showAlertModal(lang.select_baby_background_on_start, '', '');
      }
      // }
    })
    .then(() => {
      ifHaveAutofill(store, lang, maxSheets, autoFill);
    });
}


// Creat new empty book
function setNewBook(store, response, layoutId, bookId, pageId, referer, lang, autoFill) {
  const getSelectedCover = response.cover;
  const { pageHeight, pageWidth } = response.dimensions;
  const format = coverOrientation(pageWidth, pageHeight);
  // Load beliv layouts (pro or consumer)
  // Don't load layout before background select exclude autofill
  const pageType = (autoFill || format === 'landscape') ? loadProBelivTemplates : '';
  // Load pro layouts in pro book, consumer layouts will load after selected backgorund
  store.dispatch(removeDefaultLayout(layoutId));
  if (pageType !== '') {
    const layoutTemplates = pageType[format];
    for (const layout of layoutTemplates.items) {
      store.dispatch(loadLayouts(layout.layouts));
    }
  }

  // Load pro or consumer cover layout
  const coverType = getContext() === 'pro' ? loadProCoverTemplates : loadConsumerCoverTemplates;
  const coverTemplates = coverType[format][getSelectedCover.type];
  const selectedCover = coverTemplates.sizes.filter(element => element.label === getSelectedCover.label);
  if (selectedCover.length === 0) {
    throw new Error('Invalid cover type ');
  }

  let getCover = selectedCover.find(element => !element.only_autofill_layout);
  if (coverWithOnlyAutofillLayout().includes(getSelectedCover.type)) {
    getCover = autoFill
      ? selectedCover.find(element => element.only_autofill_layout)
      : selectedCover.find(element => !element.only_autofill_layout);
  }

  const placeholderBorderSize = getCover.placeholderBorderSize || 0;
  // Load cover layouts and margins
  setNewCoverAndMargin(store, [getCover]);
  setFlyLeafs(store, format);
  const { maxSheets, isBabyBook } = response;

  store.dispatch((setLayoutToActivePage(getCover.id, pageId, false, false)));
  
  if(format == 'landscape'){
    store.dispatch(changeBookBackgroundType('modern'));
  }

  loadGalleryImages(store, referer, bookId, lang, maxSheets, autoFill, getContext(), format);
  store.dispatch(addPlaceholderBorderSize(placeholderBorderSize));
  store.dispatch(addPageToViewed(10));

  const disableCovers = skipImageDropToCover();
  if (disableCovers.includes(coverTemplates.name)) {
    store.dispatch(imageChange(false));
  }

  // Set isBabyBook or not
  if (isBabyBook && isBabyBook !== undefined) {
    store.dispatch(setIsBabyBook(isBabyBook));
    store.dispatch(changeBookBackgroundType('tematikus'));
  }
}

export function loadDefaultState(store, bookId = false, autoFill = false, bookContext, lang) {
  for (const layout of defaultLayout.items) {
    store.dispatch(loadLayouts(layout.layouts));
  }
  const referer = getDomain();

  const page = {
    layout: 0,
    placeholders: [],
    order: 0,
    isActive: false,
  };
  store.dispatch(createPage(page));

  // set first layout to first page
  const [layoutId] = store.getState().entities.layouts.allIds.slice(0, 1);
  const [pageId] = store.getState().entities.pages.allIds.slice(0, 1);
  setFirstLayout(store, layoutId, pageId);

  // Load book properties
  const getBookProperties = configExist('getStateUrl', referer);
  const fetchURL = `${getBookProperties}/${bookId}`;


  fetch(fetchURL)
    .then(response => response.json())
    .then((data) => {
      if ('error' in data) {
        throw data.error;
      }

      const {
        pageWidth,
        pageHeight,
      } = data.dimensions;
      const { folderID } = data;

      // If images removed from the server
      if (Object.prototype.hasOwnProperty.call(data, 'removed') && parseInt(data.removed, 10) !== 0) {
        showAlertModal(lang.title_notice, lang.unable_to_load_book);
        throw new Error('Unable to load');
      }

      // If already ordered book
      if (Object.prototype.hasOwnProperty.call(data, 'status') && parseInt(data.status, 10) === 10) {
        showAlertModal(lang.title_notice, lang.alreadyOrderedBook);
        throw new Error('Unable to load');
      }

      store.dispatch(getBookCover(
        data.cover,
        defaultMargin(),
      ));

      const getAutofill = getAutoFill() !== null;
      store.dispatch(getBookDimensions(data.dimensions));
      store.dispatch(addFolderId(folderID));
      store.dispatch(addAutoFill(getAutofill));
    
      if(autoFill){
        store.dispatch(changeBookBackgroundType('modern'));
      }

      store.dispatch(maxSheets(parseInt(data.maxSheets, 10)));

      const pHeight = MmToPx(pageHeight);
      const pWidth = MmToPx(pageWidth);

      const { layoutHeight } = store.getState().bookProperties.dimensions;
      store.dispatch(saveBookSizes(pWidth, pHeight, data.margin, getRatio(layoutHeight, pHeight)));

      return data;
    }).then((response) => {
      const editorJSON = configExist('getStateUrl', referer);
      fetch(`${editorJSON}/${bookId}/editorjson`, {
        cors: 'no-cors',
        credentials: 'include',
      })
        .then(response => response.json())
        .then((data) => {
          // Empty book
          if ('error' in data) {
            if (data.error === 'Json field is empty') {
              setNewBook(store, response, layoutId, bookId, pageId, referer, lang, autoFill);
            } else {
              showAlertModal(lang.title_notice, lang.authentication_required);
              return;
            }
          } else {
            // Load saved book
            const coverSize = data.json.bookProperties.cover.margins;

            const { label } = response.cover;
            const url = configExist('legacyContent', referer);
            const parameters = 'api/book/';
            const filterType = getAutoFill() !== null ? '?filter=selected' : '';
            const galleryURI = `${url}/${parameters}${bookId}/galleries${filterType}`;
            store.dispatch(loadBook(galleryURI, coverSize, label, response, store, lang));
          }
          // Demo book
          if (getBookId() === null) {
            store.dispatch(addBookId(0));
          } else {
          // Normal book
            store.dispatch(addBookId(parseInt(getBookId(), 10)));
          }

          store.dispatch(addContext(bookContext));
        });
    })
    .catch(() => store.dispatch(isLoadadble(false)));
}


// WEBPACK FOOTER //
// ./src/redux/helpers/loadDefaulState.js